import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col, FormGroup } from "reactstrap";
import Select from 'react-select'
import Loader from '../Loader/Loader'

const options = {
    plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
    },
    scales: {
        y: {
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                beginAtZero: false,
                maxTicksLimit: 10,
            },
            grid: {
                drawBorder: true,
                display: false,
            },
        },
        x: {
            barPercentage: 1.6,
            grid: {
                drawBorder: true,
                display: false,
            },
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                maxTicksLimit: 50
            },
        },
    },
}
class ChartRevenue extends Component {
    constructor(props) {
        super(props);
        this.year = ""
        this.month = ""
        this.customer = ""
        this.state = {
            data: [],
            labels: [],
            isLoading: true,
            stats: [],
            customersList: [],
            customer: "",
            yearsList: [],
            monthsList: [
                { label: "Janvier", value: "01" },
                { label: "Février", value: "02" },
                { label: "Mars", value: "03" },
                { label: "Avril", value: "04" },
                { label: "Mai", value: "05" },
                { label: "Juin", value: "06" },
                { label: "Juillet", value: "07" },
                { label: "Août", value: "08" },
                { label: "Septembre", value: "09" },
                { label: "Octobre", value: "10" },
                { label: "Novembre", value: "11" },
                { label: "Décembre", value: "12" },
            ]
        };
    }
    loadStats5() {
        if (this.year !== "" && this.month !== "" && this.customer !== "") {
            this.setState({ isLoading: true })
            return fetch('https://tdb.confotex.com/api/orders-stats-5/', {
                method: 'POST',
                headers: {
                    'authorization': window.sessionStorage.getItem('session_token'),
                    "x-my-custom-header": window.sessionStorage.getItem('iduser'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    year: this.year.value,
                    month: this.month.value,
                    customer: this.customer.value,
                })
            })
                .then((reponse) => reponse.json())
                .then((data) => {
                    if (data.reponse === "true") {

                        let labels = []
                        data.stats.forEach(element => {
                            labels.push(element.abr_prod)
                        });
                        let data2 = []
                        data.stats.forEach(element => {
                            data2.push(element.qt_finie)
                        });

                        this.setState({ labels: labels, data: data2, stats: data.stats, isLoading: false })

                    } else if (data.reponse === "false") {
                        this.showNotification(data)
                    }
                    else {
                        this.setState({ isLoading: false })
                    }
                })
                .catch((error) => console.error(error));
        }
    }
    loadCustomers() {
        this.setState({ isLoading: true })
        return fetch('https://tdb.confotex.com/api/customers/', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then((reponse) => reponse.json())
            .then((data) => {
                if (data.reponse === "false") {
                    this.setState({ isLoading: false })
                } else if (data.reponse === "true") {
                    this.setState({ isLoading: false, customersList: data.customersList })
                }
            })
            .catch((error) => console.error(error));
    }
    generateYears() {
        let max = new Date().getFullYear()
        let array = []
        for (let i = 2020; i <= max; i++) {
            let obj = {}
            obj.value = i
            obj.label = i
            array.push(obj)
        }
        this.setState({ yearsList: array })
    }
    componentDidMount() {
        this.loadCustomers()
        this.generateYears()
    }
    render() {
        return (
            <>
                <Row>
                    <Col md="4">
                        <Card >
                            <CardBody className="justify-content-center d-flex">
                                <table className="table-sm table-hover table-responsive" style={{ height: 400, }}>
                                    <thead>
                                        <th>Produit</th>
                                        <th>Qte Contrôlée</th>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.stats.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{value.abr_prod}</td>
                                                        <td>{value.qt_finie}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="8">
                        <Card>
                            {/* DISPLAY LOADER */}
                            {this.state.isLoading && <div style={{ backgroundColor: "white", position: 'absolute', height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99, borderRadius: 15 }}>
                                <Loader />
                            </div>}
                            <CardHeader>
                                <CardTitle tag="h5">Quantité de produits contrôlés par client par produit par mois</CardTitle>
                                <CardHeader>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>
                                                    Client
                                                </label>
                                                <Select value={this.state.customer} options={this.state.customersList} onChange={(event) => { this.customer = event; this.setState({ customer: event }); this.loadStats5() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>
                                                    Année
                                                </label>
                                                <Select value={this.state.year} options={this.state.yearsList} onChange={(event) => { this.year = event; this.loadStats5() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <label>
                                                    Mois
                                                </label>
                                                <Select value={this.state.month} options={this.state.monthsList} onChange={(event) => { this.month = event; this.loadStats5() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </CardHeader>
                            <CardBody>
                                <Bar
                                    data={(canvas) => {
                                        return {
                                            labels: this.state.labels,
                                            datasets: [
                                                {
                                                    borderColor: "white",
                                                    backgroundColor: [
                                                        '#D98880',
                                                        '#EC7063',
                                                        '#AF7AC5',
                                                        '#A569BD',
                                                        '#5499C7',
                                                        '#5DADE2',
                                                        '#48C9B0',
                                                        '#45B39D',
                                                        '#52BE80',
                                                        '#58D68D',
                                                        '#F4D03F',
                                                        '#F5B041',
                                                        '#EB984E',
                                                        '#DC7633',
                                                        '#641E16',
                                                        '#512E5F',
                                                    ],
                                                    pointRadius: 0,
                                                    pointHoverRadius: 0,
                                                    borderWidth: 1,
                                                    tension: 0.4,
                                                    fill: true,
                                                    data: this.state.data
                                                }
                                            ],
                                        };
                                    }}
                                    options={options}
                                    width={400}
                                    height={100}
                                />
                            </CardBody>
                            <CardFooter>
                                <hr />
                                <div className="stats" onClick={() => { this.loadStats5() }}>
                                    <i className="fas fa-history" /> Actualiser
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>

                </Row>

            </>

        );
    }
}

export default ChartRevenue;
